import dayjs from "dayjs";

export function formatDate(dateToFormat: Date | null) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();

    return dayjs(dateToFormat).format(`DD/MM/YYYY - HH:mm:ss`);
  } catch (error) {
    return `--/--/---- --:--:--`;
  }
}

export function formatMonth(dateToFormat: Date | null) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();

    return dayjs(dateToFormat).format(`MM/YYYY`);
  } catch (error) {
    return `--/--/---- --:--:--`;
  }
}